import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
import { BEHAVIOR_CLICK_DELAY } from "../utils/variables";
class DoubleClickBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.id = BehaviorType.dblclick;
        this.handler = (event) => this.onDoubleClick(event);
        this.iframeBehaviorListeners = [{ type: this.id, listener: this.handler }];
    }
    onDoubleClick(event) {
        if (this.isOnHandler) {
            return;
        }
        this.isOnHandler = true;
        setTimeout(() => {
            this.addLog(event, this.id);
            this.isOnHandler = false;
        }, BEHAVIOR_CLICK_DELAY);
    }
}
export default DoubleClickBehavior;
